import {
  TBctxItemWithoutSizeAndBctxKey,
  TBCTXKeys,
  TBctxKeysToDisplayMap,
  TBCTXKeysWithoutSize,
  TBusinessContextListingItemFilter,
  TPaginationInfo,
} from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption, UiFilterModifiers } from '@monorepo/ui';
import * as _ from 'lodash';

export const BCTX_SELECTION_FILTER_MODEL = {
  createModel: (
    items: TBusinessContextListingItemFilter[],
    prevModel: TFilterGroupModel<TBusinessContextListingItemFilter>,
    bctxKeysToFilterTitles: TBctxKeysToDisplayMap,
    minCharacterLength?: Record<TBCTXKeys, number>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      const limitItemsByKeystroke: number = minCharacterLength
        ? minCharacterLength[item.filterType as TBCTXKeys] || 0
        : 0;
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: bctxKeysToFilterTitles[item.filterType],
        limitItemsByKeystroke: limitItemsByKeystroke || undefined,
        items: item.values.map((val) => {
          return {
            value: val,
            isSelected: false,
          };
        }),
        ...(item.values.length > 50 && {
          virtualScroll: {
            itemSize: 40,
            minBufferPx: window.screen.height / 2,
            maxBufferPx: window.screen.height / 2,
          },
        }),
        selectedValues: [],
      };
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
  getFilterBctxList: (
    selectedFilters: TBusinessContextListingItemFilter[],
    bctxList: TBctxItemWithoutSizeAndBctxKey[],
    userPaginationOption: TUserPaginationOption,
    orderKeys: TBCTXKeysWithoutSize[],
  ) => {
    const rangeInPageStart = (userPaginationOption.pageNo - 1) * userPaginationOption.pageSize + 1;
    const rangeInPageEnd = userPaginationOption.pageNo * userPaginationOption.pageSize;
    const filteredBctxList: TBctxItemWithoutSizeAndBctxKey[] = [];
    bctxList.forEach((itemInfo) => {
      let isFiltered = true;
      selectedFilters.forEach((selectedFilter) => {
        if (selectedFilter.values.length) {
          isFiltered =
            isFiltered &&
            selectedFilter.values.some((f) =>
              itemInfo.list.some(({ k, v }) => k === selectedFilter.filterType && f === v),
            );
        }
      });
      if (isFiltered) filteredBctxList.push({ ...itemInfo });
    });
    const supportedFilters: TBusinessContextListingItemFilter[] = [];
    orderKeys.forEach((key) => {
      const values = _.uniq(
        filteredBctxList.reduce((acc, bctxListItem) => {
          const bctxItem = bctxListItem.list.find(({ k }) => k === key);
          if (bctxItem) acc.push(bctxItem.v);
          return acc;
        }, [] as string[]),
      );
      supportedFilters.push({
        filterType: key as TBusinessContextListingItemFilter['filterType'],
        values: values.map((val) => (!val ? '--' : val)),
      });
    });
    const paginatedFilteredBctxList: TBctxItemWithoutSizeAndBctxKey[] = filteredBctxList.slice(
      rangeInPageStart - 1,
      rangeInPageEnd,
    );
    const paginationInfo: TPaginationInfo = {
      itemsPerPage: userPaginationOption.pageSize,
      rangeInPage: {
        start: rangeInPageStart,
        end: rangeInPageEnd,
      },
      totalItems: filteredBctxList.length,
      totalPageCount: BCTX_SELECTION_FILTER_MODEL.getTotalPageCount(
        filteredBctxList.length,
        userPaginationOption.pageSize,
      ),
    };
    return {
      paginationInfo,
      supportedFilters,
      paginatedFilteredBctxList,
    };
  },
  getTotalPageCount: (totalItems: number, itemsPerPage: number) => {
    return Math.ceil(totalItems / itemsPerPage);
  },
};
